export default __webpack_public_path__ + "static/shorter_fc_teaser-65151688f4b3be4fb30c1ee4ad1fa8c7.mp4";